module.exports = __webpack_public_path__ + "img/jetbrains-mono-dark.7e989644.png";